import React, { ReactNode } from 'react'
import Stack from '@mui/material/Stack'
import { SelectInput } from '../../../shared/components/SelectInput'
import { CommentsViewSelectFilterConfig } from '../CommentsView.types'
import CommentsViewFilterField from './CommentsViewFilterField'
import CommentsViewFilterAccordionSection from './CommentsViewFilterAccordionSection'

type CommentsViewTabFiltersProps = {
    title: string
    filters: CommentsViewSelectFilterConfig[]
    appliedCount?: number
    onClear?: () => void
    defaultExpanded?: boolean
    isCollapsible?: boolean
    headerActions?: ReactNode
    extraControl?: ReactNode
}

const CommentsViewTabFilters = ({
    title,
    filters,
    appliedCount = 0,
    onClear,
    defaultExpanded = false,
    isCollapsible = true,
    headerActions,
    extraControl,
}: CommentsViewTabFiltersProps) => {
    return (
        <CommentsViewFilterAccordionSection
            title={title}
            appliedCount={appliedCount}
            onClear={onClear}
            defaultExpanded={defaultExpanded || appliedCount > 0}
            isCollapsible={isCollapsible}
            headerActions={headerActions}
        >
            <Stack direction={{ xs: 'column', md: 'row' }} gap={3} width="100%" flexWrap="wrap">
                {filters.map((filter) => (
                    <CommentsViewFilterField
                        key={filter.id}
                        label={filter.label}
                        isActive={filter.isActive}
                        onClear={filter.onClear}
                    >
                        <SelectInput
                            multiple
                            selected={filter.selectedOptionIds}
                            onChange={filter.onChange}
                            options={filter.options}
                            placeholder={filter.placeholder}
                        />
                    </CommentsViewFilterField>
                ))}
                {extraControl}
            </Stack>
        </CommentsViewFilterAccordionSection>
    )
}

export default CommentsViewTabFilters
